module.exports = __webpack_public_path__ + "static/assets/56264bee3dfb230e7d95b2959c0a37f4.png";